export default "__VITE_ASSET__QLFV$8AR__"